export const LOGIN_STORAGE_KEY = "AJIFARMS_LOGIN_STORAGE_KEY";
export const LOGIN_STORAGE_KEY_USER = "AJIFARMS_LOGIN_STORAGE_KEY_USER";
